export default __webpack_public_path__ + "static/media/fulleditor_dark.a5afea64.svg";